import ReactGA from "react-ga4";

const measurementId = "G-FR3DTGZERD";

export const initGA = () => {
  ReactGA.initialize(measurementId);
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
